(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("TJA", [], factory);
	else if(typeof exports === 'object')
		exports["TJA"] = factory();
	else
		root["TJA"] = factory();
})(self, () => {
return 